module.exports = __webpack_public_path__ + "img/image1.0bdc25ed.jpg";